import React from "react";

function Tile({school, deg, cgpa, time}) {
  return (
    <div className="tile-content">
      <h3 className="tile-content__heading">
       {school}
      </h3>
      <h4 className="tile-content__subheading"> {deg}</h4>
      <h4 className="tile-content__subheading2"> {cgpa}</h4>
      <div className="tile-content__time-box">
      <img
              src="./icons/time.svg"
              className="tile-content__icon"
              alt="Time"
            />
        <p className="tile-content__time"> {time}</p>
      </div>
    </div>
  );
}

export default Tile;
